import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Record from './components/Record.vue'
import Login from './components/Login.vue'
import Signup from './components/Signup.vue'
import JobListing from './components/JobListing.vue'
import VueRouter from 'vue-router';
import Cookies from 'js-cookie'

Vue.use(Router)


const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/signup',
    name: 'signup',
    component: Signup
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  },
  {
    path: '/record',
    name: 'record',
    component: Record
  },
  {
    path: '/listing',
    name: 'job-listing',
    component: JobListing,
    beforeEnter: (to, from, next) => {
      if( Cookies.get('auth_token') && Cookies.get('role') !== 'Admin' )
      {
        // next({
        //   name: 'record'
        // })
        next({
          name: 'record'
        })
      }
      else if(Cookies.get('auth_token') && Cookies.get('role') === 'Admin'){
        next()
      }

    }
  }
]

export const router = new VueRouter({
  routes,
  mode: 'history'
});

router.beforeEach((to, from, next) => {
  if(to.query.route) {
    Cookies.set('route', to.query.route)
  }


  if( !Cookies.get('auth_token') && to.name !== 'login' && to.name !== 'signup' )
  {
    // console.log(">>>>>>>", process.env.BASE_URL) 
    next({
      name: 'login'
    })
  }
  else if( Cookies.get('auth_token') && (to.name === 'login' || to.path === '/' ) && Cookies.get('role') === 'Admin' )
  {
    next({
      name: 'job-listing'
    })

  }
  else if(Cookies.get('auth_token') && (to.name === 'login' || to.path === '/' )){
    // console.log("Had token")
    next({
      name: 'record'
    })
  } 
  else {
    // console.log("Else", to)
    if(to.name === null){
      next(false)
    } else {
      next({
        name: to
      })
    }  
  }
})
